import type { CandidateLesson } from '../types';

// Fenêtre « Nouvelle leçon programmée » (J25, 28/10/2026) : en plus de la notification, l'espace élève annonce une
// leçon que l'auto-école vient de planifier, avec « OK » seulement (ni accepter ni refuser). Leçons vues mémorisées
// par élève dans le navigateur ; règles pures, sans React.

/** Jours pendant lesquels une leçon posée par l'auto-école est annoncée ; au-delà, l'élève la connaît. */
export const NEW_LESSON_DAYS = 14;

export const seenLessonsKey = (candidateId: string) => `pmd-candidat-lessons-seen:${candidateId}`;

/**
 * Leçons à annoncer, de la plus proche à la plus lointaine : planifiées par l'auto-école (pas réservées en ligne),
 * à venir, non annulées, posées depuis moins de 14 jours et pas encore vues. Serveur plus ancien (sans `plannedAt`) :
 * aucune.
 */
export function lessonsToAnnounce(lessons: CandidateLesson[], seen: string[], now: number): CandidateLesson[] {
  return lessons
    .filter((l) => {
      if (l.bookedOnline || l.status !== 'scheduled' || seen.includes(l.id) || !l.plannedAt) return false;
      const planned = new Date(l.plannedAt).getTime();
      return new Date(l.startsAt).getTime() > now && now - planned <= NEW_LESSON_DAYS * 86_400_000;
    })
    .sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime());
}

/** Leçons vues après « OK » : les nouvelles, et les anciennes encore dans la liste (la liste ne grossit pas sans fin). */
export function markSeen(seen: string[], lessons: CandidateLesson[], shown: CandidateLesson[]): string[] {
  const known = new Set(lessons.map((l) => l.id));
  return Array.from(new Set([...seen.filter((id) => known.has(id)), ...shown.map((l) => l.id)]));
}
